import Mention from '@tiptap/extension-mention';
import { ReactRenderer } from '@tiptap/react';
import React from 'react';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

const MentionList = ({ items, command }) => {
  if (!items || items.length === 0) {
    return (
      <div className="mention-dropdown">
        <div className="mention-item-empty">No users found</div>
      </div>
    );
  }

  return (
    <div className="mention-dropdown">
      {items.map((item, index) => {
        const displayName =
          item.Name ||
          `${item.FirstName || ''} ${item.LastName || ''}`.trim() ||
          'Unknown';
        const id = item.StaffGuid || item.Guid || item.id || displayName;

        return (
          <div
            key={id + '-' + index}
            className="mention-item"
            onClick={() =>
              command({
                id,
                label: displayName,
              })
            }
          >
            {displayName}
          </div>
        );
      })}
    </div>
  );
};

export default function CustomMention(users = []) {
  return Mention.extend({
    addStorage() {
      return {
        mentionUsers: users || [],
        disableMentions: false,
      };
    },

    addAttributes() {
      return {
        ...this.parent?.(),
        label: {
          default: null,
          parseHTML: (element) => {
            const label = element.getAttribute('data-label');
            if (label) return label;
            return element.textContent?.replace(/^@/, '') || null;
          },
          renderHTML: (attributes) => {
            if (!attributes.label) return {};
            return {
              'data-label': attributes.label,
            };
          },
        },
      };
    },

    parseHTML() {
      return [
        { tag: 'span[data-type="mention"]' },
        { tag: 'span.mention[data-id]' },
      ];
    },

    renderHTML({ node }) {
      return [
        'span',
        {
          class: 'mention',
          'data-type': 'mention',
          'data-id': node.attrs.id,
          'data-label': node.attrs.label,
        },
        `@${node.attrs.label}`,
      ];
    },

    addOptions() {
      return {
        ...this.parent?.(),
        suggestion: {
          char: '@',
          allow: ({ editor }) => {
            return !editor.storage?.mention?.disableMentions;
          },
          items: ({ query, editor }) => {
            const list = editor.storage?.mention?.mentionUsers || [];
            if (!query) return list;
            return list.filter((u) => {
              const name = u.Name || `${u.FirstName || ''} ${u.LastName || ''}`;
              return name.toLowerCase().includes(query.toLowerCase());
            });
          },
          command: ({ editor, range, props }) => {
            editor
              .chain()
              .focus()
              .insertContentAt(range, [
                {
                  type: 'mention',
                  attrs: { id: props.id, label: props.label },
                },
                { type: 'text', text: ' ' },
              ])
              .run();
          },
          render: () => {
            let reactRenderer;
            let popup;

            return {
              onStart: (props) => {
                reactRenderer = new ReactRenderer(MentionList, {
                  props,
                  editor: props.editor,
                });

                if (!props.clientRect) return;

                popup = tippy('body', {
                  getReferenceClientRect: props.clientRect,
                  appendTo: () => document.body,
                  content: reactRenderer.element,
                  showOnCreate: true,
                  interactive: true,
                  trigger: 'manual',
                  placement: 'top-start',
                });
              },
              onUpdate(props) {
                reactRenderer?.updateProps(props);
                if (props.clientRect && popup?.[0]) {
                  popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                  });
                }
              },
              onExit() {
                if (popup?.[0]) {
                  popup[0].destroy();
                }
                if (reactRenderer) {
                  reactRenderer.destroy();
                }
              },
            };
          },
        },
      };
    },
  });
}
